/** Site-wide identity and URLs for SEO, AEO, and GEO. */

const DEFAULT_SITE_NAME = "Zoniq EventOS";
const DEFAULT_TAGLINE = "The operating system for modern event teams";
const DEFAULT_DESCRIPTION =
  "Plan events, track finances, manage live operations, and generate GST invoices. Zoniq EventOS unifies event planning, live ticket ops, P&L dashboards, and Indian GST billing for agencies, promoters, and venues.";

export const SITE = {
  name: DEFAULT_SITE_NAME,
  shortName: "EventOS",
  legalName: "Zoniq",
  tagline: DEFAULT_TAGLINE,
  description: DEFAULT_DESCRIPTION,
  locale: "en_IN",
  language: "en",
  twitterHandle: "@zoniq",
  contactEmail: "hello@zoniq.com",
  /** Primary product category for schema.org */
  applicationCategory: "BusinessApplication",
  operatingSystem: "Web",
} as const;

/** Absolute site origin — set REACT_APP_SITE_URL in production (no trailing slash). */
export function getSiteOrigin(): string {
  const configured = process.env.REACT_APP_SITE_URL?.trim().replace(/\/$/, "");
  if (configured) return configured;
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }
  return "";
}

export function absoluteUrl(path = "/"): string {
  const origin = getSiteOrigin();
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return origin ? `${origin}${normalized}` : normalized;
}

export function defaultOgImageUrl(): string {
  return absoluteUrl("/icon-512.png");
}
